// @Version: 1.0.0
export enum FC_DATE {
   DATE = "date"
}

export enum DATEFORMATCALENDER {
   DATE = "date",
   MONTHYEAR = "month-year",
   YEAR = "year"
}

export enum DATESTARTVIEW {
   MULTIYEAR = "multi-year",
   MONTH = "month"
}

export enum DATEFORMAT {
   INVALID = "Invalid date",
   DE = "DD.MM.YYYY",
   DE_PIPE = "dd.MM.YYYY",
   MOMENT = "DD.MM.yyyy",
   EN = "YYYY-MM-DD",
   MONTH_YEAR = "MM.YYYY",
   YEAR = "YYYY",
   LABEL_MONTH_YEAR = "MMM YYYY",
   DATE_A11_LABEL = "LL",
   MONTH_YEAR_A11Y_LABEL = "MMMM YYYY",
   MONTH_DAY = "MM.DD.YYYY"
}

export enum RELATIVEDATEFORMAT {
   DAY = 0,
   MONTH,
   YEAR
}